import { Nav, Tab } from "react-bootstrap";
import PropTypes from 'prop-types';
import ResumenTab from "./tabs/ResumenTab";
import TicketsTab from "./tabs/TicketsTab";
import EstudiantesTab from "./tabs/EstudiantesTab";
import FuncionariosTab from "./tabs/FuncionariosTab";
import EncuestaTab from "./tabs/EncuestaTab";
import NuevaEncuestaTab from "./tabs/NuevaEncuestaTab";

function DashboardTabs({ activeTab, onTabSelect }) {
  const tabs = [
    { key: "resumen", label: "Resumen", component: <ResumenTab /> },
    { key: "tickets", label: "Tickets y Atenciones", component: <TicketsTab /> },
    { key: "estudiantes", label: "Estudiantes", component: <EstudiantesTab /> },
    { key: "funcionarios", label: "Funcionarios", component: <FuncionariosTab /> },
    { key: "encuesta", label: "Encuesta de Satisfacción", component: <NuevaEncuestaTab /> },
  ];

  // Estilos personalizados para las pestañas
  const tabStyles = `
    .nav-tabs .nav-link {
      color: #6c757d !important;
      border-color: transparent !important;
      font-weight: 500;
    }
    
    .nav-tabs .nav-link:hover {
      color: #495057 !important;
      border-color: transparent !important;
    }
    
    .nav-tabs .nav-link.active {
      color: var(--color-accent) !important;
      border-color: transparent transparent var(--color-accent) !important;
      border-bottom-width: 3px !important;
      background-color: transparent !important;
    }
  `;

  return (
    <Tab.Container activeKey={activeTab} onSelect={onTabSelect}>
      <style>{tabStyles}</style>
      <div className="bg-white rounded shadow-sm border">
        <Nav variant="tabs" className="border-0 px-3 pt-3">
          {tabs.map((tab) => (
            <Nav.Item key={tab.key}>
              <Nav.Link eventKey={tab.key}>{tab.label}</Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        <Tab.Content className="p-4">
          {tabs.map((tab) => (
            <Tab.Pane key={tab.key} eventKey={tab.key}>
              {tab.component}
            </Tab.Pane>
          ))}
        </Tab.Content>
      </div>
    </Tab.Container>
  );
}

DashboardTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onTabSelect: PropTypes.func.isRequired,
};

export default DashboardTabs;
